import styled from 'styled-components';
import toColorString from 'polished/lib/color/toColorString';
import rem from 'polished/lib/helpers/rem';

import spacing from '@decisiv/design-tokens/lib/spacing';
import color from '@decisiv/design-tokens/lib/color';

import Flex from '@decisiv/ui-components/lib/components/Flex';

import NoWrapHeaderTable from 'components/NoWrapHeaderTable';

export const OverflowTable = styled(NoWrapHeaderTable)`
  overflow: auto;
` as typeof NoWrapHeaderTable;

export const Container = styled(Flex)`
  flex-direction: column;
  flex: 1;
  background-color: ${toColorString(color.base.fullMoon)};

  overflow: hidden;
`;

export const Filters = styled(Flex).attrs({ paddingY: 1, paddingX: 2 })`
  align-items: center;
  gap: ${rem(spacing.base)};

  border-bottom: 1px solid ${toColorString(color.base.quarterMoon)};
`;

export const Header = styled(Flex).attrs({ paddingY: 0.5, paddingX: 2 })`
  align-items: center;
  gap: ${rem(spacing.base)};

  border-bottom: 1px solid ${toColorString(color.base.quarterMoon)};
`;

/** The filters inside a `FiltersBar`; they wrap onto a second row when narrow. */
export const FilterGroup = styled(Flex)`
  flex: 1 1 auto;
  flex-wrap: wrap;
  align-items: center;
  gap: ${rem(spacing.base)};
`;

/**
 * Bar between the filters and a table that holds its count and bulk actions.
 * halfMoon matches the KDS table head under it (PD-5930 UX review).
 */
export const ActionsBar = styled(Header)`
  background-color: ${toColorString(color.base.halfMoon)};
`;

/**
 * White filters bar of the PD-5874 Fleet Management pages (All Teams and the
 * Team page). Pair it with `FilterGroup` and `pages/Management/components/
 * ToolbarSearch`, which wrap onto extra rows instead of squeezing their text.
 */
export const FiltersBar = styled(Filters)`
  background-color: ${toColorString(color.base.snowWhite)};

  /* No line between the filters and an ActionsBar under them (PD-5930 UX review). */
  &:has(+ ${ActionsBar}) {
    border-bottom: none;
  }
`;

export const ActivityList = styled(Flex).attrs({
  paddingX: 2,
  paddingTop: 2,
  marginBottom: 2,
})`
  flex-direction: column;
  flex: 1;
  gap: ${rem(spacing.base)};
  overflow: auto;
`;
